module.exports = __webpack_public_path__ + "static/flags/IO-95da5bb24d2bd5b463c30e00aab685da.gif";